if (!customElements.get('ly-faq-list-tab')) {
    customElements.define('ly-faq-list-tab', class extends LyFullScrollCarousel {

        connectedCallback() {
            super.connectedCallback()

            this.tabWrapper = this.querySelector('[data-tab-wrapper]')
            this.tabWrapper.addEventListener('change', this.handleTabChange)
        }

        disconnectedCallback() {
            this.tabWrapper.removeEventListener('change', this.handleTabChange)

            super.disconnectedCallback()
        }


        handleTabChange = (evt) => {
            this._index = Number(evt.target.value || 0)
        }

        _onIndexChanged = () => {
            this.style.setProperty('--active-i', this._index)
        }
    })
}

if (!customElements.get('ly-faq-list-tab-content-line')) {
    customElements.define('ly-faq-list-tab-content-line', class extends HTMLElement {
        connectedCallback() {
            this.checkbox = this.querySelector('input')

            this.handleChange()
            this.checkbox.addEventListener('change', this.handleChange)
        }

        disconnectedCallback() {
            this.checkbox.removeEventListener('change', this.handleChange)
        }

        handleChange = () => {
            this.classList.toggle('is-open', this.checkbox.checked)
        }
    })
}